/* merchant-module-shopify-sync.js — Shopify catalog explorer + price sync
 *
 * Loaded by /pages/admin-merchant. When the user clicks the "In Shopify (auto)" tab,
 * this script:
 *   1. Pages through /products.json to list every sync-on-demand product (handles
 *      prefixed by amazon-/aliexpress-/sephora-/macys-/shein-).
 *   2. Renders cards showing current Shopify price, status, stock, source.
 *   3. Exposes "Check first N from API" (rate-limit safe) and "Auto-refresh deltas"
 *      buttons that hit the existing prepare-cart pipeline (same as PDP add-to-cart).
 *
 * Rate-limit safe: 1 worker with 600ms gap. Backend free tier is sensitive.
 */
(function(){
  'use strict';

  function $(id){ return document.getElementById(id); }
  function escHtml(s){ return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }

  function init(){
    var grid = document.getElementById('dh-mm-grid');
    var tab = document.querySelector('.dh-mm__tab[data-tab="shopify"]');
    if (!grid || !tab) return;
    tab.addEventListener('click', function(e){
      e.stopImmediatePropagation();
      loadShopifyTab(grid);
    }, true);
  }

  async function loadShopifyTab(grid){
    document.querySelectorAll('.dh-mm__tab').forEach(function(b){
      b.classList.toggle('is-active', b.dataset.tab === 'shopify');
    });
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '<div class="dh-mm__loader">Loading Shopify catalog…</div>';

    var items = [];
    try {
      for (var page = 1; page <= 12; page++){
        var r = await fetch('/products.json?limit=250&page=' + page, { credentials: 'omit' });
        var d = await r.json();
        if (!d.products || !d.products.length) break;
        for (var i = 0; i < d.products.length; i++){
          var p = d.products[i];
          var m = p.handle.match(/^(amazon|aliexpress|sephora|macys|shein)-([a-z0-9]+)/i);
          if (!m) continue;
          items.push({
            source: m[1].toLowerCase(),
            sourceId: m[2].toUpperCase(),
            shopifyId: p.id,
            handle: p.handle,
            title: p.title,
            image: p.images && p.images[0] ? p.images[0].src : '',
            currentPrice: parseFloat((p.variants && p.variants[0] && p.variants[0].price) || '0'),
            available: p.variants && p.variants.some(function(v){ return v.available; }),
            status: p.published_at ? 'active' : 'draft',
            updatedAt: p.updated_at
          });
        }
        if (d.products.length < 250) break;
      }
    } catch (err) {
      grid.innerHTML = '<div class="dh-mm__empty">Could not load: ' + escHtml(err.message) + '</div>';
      return;
    }

    // Sort newest first
    items.sort(function(a,b){ return (b.updatedAt||'').localeCompare(a.updatedAt||''); });
    window.__dhmShopify = items;
    renderShopifyGrid(grid, items);
    addControlButtons();
  }

  function renderShopifyGrid(grid, items){
    var statTotal = $('dh-mm-stat-total');
    if (statTotal) statTotal.textContent = items.length;

    if (!items.length){
      grid.innerHTML = '<div class="dh-mm__empty">No sync-on-demand products in Shopify yet. Use the API tabs to Pre-sync some.</div>';
      grid.setAttribute('aria-busy', 'false');
      return;
    }

    var cards = items.map(function(p){
      var img = (p.image || '').replace(/^\/\//, 'https://');
      var key = p.source + ':' + p.sourceId;
      return '<article class="dh-mm__card" data-key="' + escHtml(key) + '" data-shopify-id="' + p.shopifyId + '" data-handle="' + escHtml(p.handle) + '">'
        + '<a class="dh-mm__cardlink" href="/products/' + escHtml(p.handle) + '" target="_blank" rel="noopener">'
        + '<div class="dh-mm__img">' + (img ? '<img src="' + img + '" loading="lazy" alt="">' : '') + '</div></a>'
        + '<div class="dh-mm__body">'
        + '<h3>' + escHtml(p.title) + '</h3>'
        + '<div class="dh-mm__meta">'
        +   '<span class="dh-mm__price">$' + p.currentPrice.toFixed(2) + '</span>'
        +   '<span class="dh-mm__chip ' + (p.status === 'active' ? 'dh-mm__chip--ok' : 'dh-mm__chip--warn') + '">' + p.status + '</span>'
        +   '<span class="dh-mm__chip ' + (p.available ? 'dh-mm__chip--ok' : 'dh-mm__chip--warn') + '">' + (p.available ? 'in stock' : 'OOS') + '</span>'
        +   '<span class="dh-mm__chip">' + p.source + '</span>'
        + '</div>'
        + '<div class="dh-mm__meta" data-delta-cell></div>'
        + '</div></article>';
    });
    grid.innerHTML = cards.join('');
    grid.setAttribute('aria-busy', 'false');
  }

  function addControlButtons(){
    var bar = document.querySelector('.dh-mm__bulkbar');
    if (!bar) return;
    if ($('dh-mm-shopify-controls')) return;
    var box = document.createElement('span');
    box.id = 'dh-mm-shopify-controls';
    box.style.display = 'inline-flex';
    box.style.gap = '6px';
    box.style.flexWrap = 'wrap';
    box.innerHTML = ''
      + '<button id="dh-mm-check50" class="dh-mm__btn dh-mm__btn--ghost">🔍 Check first 50 from API</button>'
      + '<button id="dh-mm-check-all" class="dh-mm__btn dh-mm__btn--ghost">🔍 Check ALL (slow)</button>'
      + '<button id="dh-mm-refresh-all" class="dh-mm__btn">⚡ Auto-refresh ALL via prepare-cart</button>';
    bar.appendChild(box);
    $('dh-mm-check50').addEventListener('click', function(){ checkBatch(50); });
    $('dh-mm-check-all').addEventListener('click', function(){ checkBatch(99999); });
    $('dh-mm-refresh-all').addEventListener('click', refreshAllViaPrepareCart);
  }

  // Lookup price by hitting prepare-cart which is the same pipeline as PDP add-to-cart.
  // It returns the latest snapshot from the source. Rate-limit safe via 1 worker + 700ms gap.
  async function checkBatch(maxCount){
    var items = (window.__dhmShopify || []).slice(0, maxCount);
    if (!items.length) return;
    var btn1 = $('dh-mm-check50'), btn2 = $('dh-mm-check-all');
    if (btn1) btn1.disabled = true;
    if (btn2) btn2.disabled = true;

    var deltas = [];
    for (var i = 0; i < items.length; i++){
      var p = items[i];
      var card = document.querySelector('[data-key="' + p.source + ':' + p.sourceId + '"]');
      if (!card) continue;
      var cell = card.querySelector('[data-delta-cell]');
      if (!cell) continue;
      cell.innerHTML = '<span class="dh-mm__chip" style="opacity:.6">checking… ' + (i+1) + '/' + items.length + '</span>';

      // Single prepare-cart call with QC the response
      var apiPrice = null, apiAvailable = null, apiTitle = null, status = 0;
      try {
        var r = await fetch('https://dealshub-search.onrender.com/api/prepare-cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ source: p.source, sourceId: p.sourceId, id: p.sourceId, quantity: 1 })
        });
        status = r.status;
        var d = await r.json().catch(function(){return null;});
        if (d){
          apiPrice = (d.priceSnapshot && d.priceSnapshot.price) || (d.product && d.product.price) || d.price || null;
          apiAvailable = (typeof d.availability === 'boolean') ? d.availability : (d.product && d.product.availability);
          apiTitle = d.product && d.product.title;
          if (apiPrice) apiPrice = Number(apiPrice);
        }
      } catch (e) {}

      if (status === 429){
        cell.innerHTML = '<span class="dh-mm__chip dh-mm__chip--warn">rate-limited — pausing 6s</span>';
        await sleep(6000);
        i--; // retry
        continue;
      }

      if (apiPrice == null){
        cell.innerHTML = '<span class="dh-mm__chip dh-mm__chip--warn">no API data (HTTP ' + status + ')</span>';
      } else {
        var diff = apiPrice - p.currentPrice;
        var pct = p.currentPrice ? ((diff / p.currentPrice) * 100) : 0;
        card.dataset.apiPrice = apiPrice;
        card.dataset.diff = diff.toFixed(2);
        if (Math.abs(diff) < 0.50){
          cell.innerHTML = '<span class="dh-mm__chip dh-mm__chip--ok">price ok ($' + apiPrice.toFixed(2) + ')</span>';
        } else {
          cell.innerHTML = '<span class="dh-mm__chip">API $' + apiPrice.toFixed(2) + '</span>'
            + '<span class="dh-mm__chip dh-mm__chip--warn">Δ ' + (diff>0?'+':'') + '$' + diff.toFixed(2) + ' (' + pct.toFixed(1) + '%)</span>';
          deltas.push(p);
        }
      }
      await sleep(700);
    }

    if (btn1) btn1.disabled = false;
    if (btn2) btn2.disabled = false;
    window.__dhmDeltas = deltas;

    if (deltas.length){
      alert('Found ' + deltas.length + ' products with price delta. Click "⚡ Auto-refresh ALL via prepare-cart" to push new prices via the existing pipeline.');
    } else {
      alert('Checked ' + items.length + ' products. No significant price deltas found.');
    }
  }

  // Push every product through prepare-cart pipeline. This refreshes the source snapshot.
  // For real Shopify price update we still need POST /api/admin/sync-product with CORS — fallback noted.
  async function refreshAllViaPrepareCart(){
    var items = window.__dhmShopify || [];
    if (!items.length) return alert('Load the catalog first.');
    if (!confirm('Run prepare-cart for ALL ' + items.length + ' products? This refreshes the backend snapshot from RapidAPI.\n\nFor actual Shopify price+stock writes, your backend needs POST /api/admin/sync-product with CORS open for stylehubmiami.com.\n\nThis run takes ~' + Math.round(items.length*0.7/60) + ' minutes (rate-limit safe).')) return;
    var btn = $('dh-mm-refresh-all');
    btn.disabled = true;
    var ok = 0, err = 0;
    for (var i = 0; i < items.length; i++){
      var p = items[i];
      btn.textContent = 'Refreshing ' + (i+1) + '/' + items.length + '…';
      var success = false;
      // Path 1: prepare-cart pipeline (production-tested, also runs on PDP add-to-cart)
      try {
        var r = await fetch('https://dealshub-search.onrender.com/api/prepare-cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ source: p.source, sourceId: p.sourceId, id: p.sourceId, quantity: 1 })
        });
        if (r.status === 429){ await new Promise(function(r){setTimeout(r,6000);}); i--; continue; }
        if (r.ok) success = true;
      } catch (e){}
      // Path 2: prepare-cart fallback
      if (!success){
        try {
          var r2 = await fetch('https://dealshub-search.onrender.com/api/prepare-cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ source: p.source, sourceId: p.sourceId, id: p.sourceId, quantity: 1 })
          });
          if (r2.status === 429){ await new Promise(function(r){setTimeout(r,6000);}); i--; continue; }
          if (r2.ok) success = true;
        } catch (e2){}
      }
      if (success){ ok++; markCardSynced(p); }
      else { err++; }
      await new Promise(function(r){setTimeout(r,700);});
    }
    btn.disabled = false;
    btn.textContent = '⚡ Auto-refresh ALL via prepare-cart';
    alert(ok + ' refreshed, ' + err + ' failed.\n\nFor write-back to Shopify, configure backend endpoint /api/admin/sync-product with CORS for stylehubmiami.com.');
  }

  function markCardSynced(p){
    var card = document.querySelector('[data-key="' + p.source + ':' + p.sourceId + '"]');
    if (!card) return;
    var cell = card.querySelector('[data-delta-cell]');
    if (cell) cell.innerHTML = '<span class="dh-mm__chip dh-mm__chip--ok">✓ refreshed from API</span>';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
